import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { State } from "../../../reducers/reducer";
import OverviewTableFulfillmentView from "../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/OverviewTableFulfillment";

interface Props {
  data: any;
}

export default compose<Props, {}>(
  connect(
    (state: State) => ({
      data: state.sustainability.allocation.multiStep.sustainability_quantities,
    }),
    (dispatch: any) => ({
      dispatch,
    })
  ),
  lifecycle<Props, State>({
    componentDidMount() {},
  })
)(OverviewTableFulfillmentView);
